VIV.behaviours.blockOverview = (function () {

    const attach = function (context) {
        context.querySelectorAll('.blockOverview').forEach(element => {
            init(element);
        });
    };

    const init = function (element) {

    };

    return {
        attach: attach
    }
})();
